import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import apiRequest from '../../api/request';
import { formatDataForDataTable } from '../../utils/formatData';
import { get, method } from 'lodash';

const initialState = {
  loading: false,
  leadUpdateloading: false,
  localBodies: [],
  country: [],
  state: [],
  district: [],
  courseFeeOption: [],
  sessionPrize: [],
  optionsLoading: false,
  assetDash: {},
  assetDashDeatil: [],
  fileName: {},
  paymentDates: {},
  titleAndFields: {},
  cartEditRequests: [],
  approvalStatuses: [],
  editLogs: [],
  dataUserUnder: [],
  allUsers: [],
  alldepartments: [],
  wingsunderdpt: [],
  designationsunderwings: [],
  usertypeunderdesignation: [],
  allprojects: [],
  formToken: null,
  relWith: [],
  user: {},
  language: [],
  contaboUploading: {
    loading: false,
    data: [],
  },
  submitLoading: false,
  placementTrackerTable: {
    data: [],
    loading: false,
    meta: {},
  },
  placementTrackerAnalyticsTable: {
    data: [],
    loading: false,
    meta: {},
  },
  placementTrackerAnalyticsTableCards: {
    data: [],
    loading: false,
  },
  placementTrackerAnalyticsTableGraph: {
    data: [],
    loading: false,
  },
  placementTrackerCourses: {
    data: [],
    loading: false,
  },
  placementTrackerCoursesTable: {
    data: [],
    loading: false,
  },
  placementTrackerSession: {
    data: [],
    loading: false,
  },
  placementTrackerSessionStudent: {
    data: [],
    loading: false,
  },
};

export const getProfileGeneral = createAsyncThunk('general/getProfileGeneral', async (e) => {
  const res = await apiRequest({
    method: 'get',
    url: 'users',
  });

  return res;
});

export const getLocalBodyPreData = createAsyncThunk('general/getLocalBodyPreData', async () => {
  const res = await apiRequest({
    method: 'get',
    url: `general/localBody?limit=no`,
  });

  return res;
});

export const getCountryPreData = createAsyncThunk('general/getCountryPreData', async () => {
  const res = await apiRequest({
    method: 'get',
    url: `general/countries?limit=no`,
  });

  return res;
});

export const getStatePreData = createAsyncThunk('general/getStatePreData', async (countryId) => {
  const res = await apiRequest({
    method: 'get',
    url: `general/states/${countryId}?limit=no`,
  });

  return res;
});

export const postStatePreData = createAsyncThunk('general/postStatePreData', async ({ countryId, stateName }) => {
  const res = await apiRequest({
    method: 'post',
    url: `general/states`,
    data: { countryId, stateName },
  });

  return res;
});
export const postDistrictPreData = createAsyncThunk(
  'general/postDistrictPreData',
  async ({ stateId, districtName }) => {
    const res = await apiRequest({
      method: 'post',
      url: `general/district`,
      data: { stateId, districtName },
    });

    return res;
  },
);
export const getDistrictPreData = createAsyncThunk('general/getDistrictPreData', async (stateId) => {
  const res = await apiRequest({
    method: 'get',
    url: `general/district/${stateId}?limit=no`,
  });

  return res;
});

export const updateLead = createAsyncThunk('general/updateLead', async (data) => {
  const res = await apiRequest({
    method: 'patch',
    url: `lead/leadEdit/${data.admnNo}`,
    data: data,
  });

  return res;
});

export const getCourseFeeOptions = createAsyncThunk('general/getCourseFeeOptions', async (data) => {
  const res = await apiRequest({
    method: 'get',
    url: `general/courses-options/${data.courseId}?finYear=${data.finYear}&currency=${data.currency}`,
  });

  return res;
});

export const getSessionPrize = createAsyncThunk('general/getSessionPrize', async (courseId) => {
  const res = await apiRequest({
    method: 'get',
    url: `general/courses-prices/${courseId}`,
  });

  return res;
});

export const getAssetDash = createAsyncThunk('general/getAssetDash', async () => {
  const res = await apiRequest({
    method: 'get',
    url: `asset-dashboard`,
  });

  return res;
});

export const getAssetDashDetail = createAsyncThunk('general/getAssetDashDetail', async (data) => {
  const res = await apiRequest({
    method: 'get',
    url: `/asset-dashboard/asset-details?type=${data.type}&page=${data.page}&limit=${data.limit}&search=${data.search}`,
  });

  return res;
});

export const holdPaymentUpload = createAsyncThunk('general/holdPaymentUpload', async (file) => {
  const res = await apiRequest({
    method: 'post',
    url: `general/upload`,
    data: { incomeScreenshot: file },
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return res;
});
export const generalSingleUpload = createAsyncThunk('general/generalSingleUpload', async (file, action) => {
  const res = await apiRequest({
    method: 'post',
    url: `general/file-upload`,
    data: file,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  if (res.status === 'success') return res;
  else {
    return action.rejectWithValue(res);
  }
});
export const getPaymentDate = createAsyncThunk('general/getPaymentDate', async (data) => {
  const res = await apiRequest({
    method: 'post',
    url: `general/termView`,
    data: data,
  });

  return res;
});
export const getTitleAndFields = createAsyncThunk('general/getTitleAndFields', async (data) => {
  const res = await apiRequest({
    method: 'get',
    url: `/support-request/finance-related-fields`,
    data: data,
  });
  return res;
});
export const makeCartEditRequest = createAsyncThunk('general/makeCartEditRequest', async (data) => {
  const res = await apiRequest({
    method: 'post',
    url: `/support-request/cart-edit-requests`,
    data: data,
  });
  return res;
});
export const updateCartEditRequest = createAsyncThunk('general/updateCartEditRequest', async (data) => {
  const res = await apiRequest({
    method: 'put',
    url: `support-request/cart-edit-requests/${data.request_id}`,
    data: data,
  });
  return res;
});
export const getCartEditRequests = createAsyncThunk('general/getCartEditRequests', async (data) => {
  const res = await apiRequest({
    method: 'get',
    url: `support-request/cart-edit-requests?page=${data.page}&limit=${data.limit}&search=${data.search}`,
  });
  return res;
});

export const approveOrRejectFinanceForCartEditRequest = createAsyncThunk(
  'general/approveOrRejectFinanceForCartEditRequest',
  async (data) => {
    const res = await apiRequest({
      method: 'post',
      url: `/${data.requestId}/${data.status}`,
    });
    return res;
  },
);

export const deleteEditRequest = createAsyncThunk('asset/deleteEditRequest', async (id) => {
  const res = await apiRequest({
    method: 'delete',
    url: `support-request/cart-edit-requests/${id}`,
  });
  return res;
});

export const getSingleRequest = createAsyncThunk('general/getSingleRequest', async (requestId) => {
  const res = await apiRequest({
    method: 'get',
    url: `support-request/get-single-cart-edit-requests/${requestId}`,
  });
  return res;
});

export const getApprovalstatuses = createAsyncThunk('general/getApprovalstatuses', async () => {
  const res = await apiRequest({
    method: 'get',
    url: `support-request/approval-status-data`,
  });
  return res;
});

export const postApprovalStatus = createAsyncThunk('general/postApprovalStatus', async (data) => {
  const res = await apiRequest({
    method: 'post',
    url: `support-request/status-change/${data.requestId}`,
    data: data,
  });
  return res;
});
export const updateApprovalstatus = createAsyncThunk('general/updateApprovalstatus', async (data) => {
  const res = await apiRequest({
    method: 'put',
    url: `support-request/status-change/${data.requestId}`,
    data: data,
  });
  return res;
});

export const postApprovalFinance = createAsyncThunk('general/postApprovalFinance', async (data) => {
  const res = await apiRequest({
    method: 'post',
    url: `support-request/finance-approval/${data.requestId}`,
    data: data,
  });
  return res;
});

export const getEditLogs = createAsyncThunk('general/getEditLogs', async (requestID) => {
  const res = await apiRequest({
    method: 'get',
    url: `support-request/get-changed-datas/${requestID}`,
  });
  return res;
});

export const getUserUnder = createAsyncThunk('general/getUserUnder', async () => {
  const res = await apiRequest({
    method: 'get',
    url: `general/get-user-details`,
  });
  return res;
});

export const getAllUsersNew = createAsyncThunk('general/getAllUsersNew', async () => {
  const res = await apiRequest({
    method: 'get',
    url: `/general/get-all-users-details`,
  });
  return res;
});

export const getAlldepartments = createAsyncThunk('general/alldepartments', async () => {
  const res = await apiRequest({
    method: 'get',
    url: 'department-management/getDepartments?page=1&limit=no',
  });
  return res;
});

export const getWingsUnderdpt = createAsyncThunk('general/getWingsUnderdpt', async (departmentId) => {
  const res = await apiRequest({
    method: 'get',
    url: `users/get-wings/${departmentId}`,
  });
  return res;
});

export const getDesignationUnderWings = createAsyncThunk('general/getDesignationUnderWings', async (wingId) => {
  const res = await apiRequest({
    method: 'get',
    url: `general/get-designations/${wingId}`,
  });
  return res;
});

export const getUserTypeUnderDesignation = createAsyncThunk(
  'general/getUserTypeUnderDesignation',
  async (designationID) => {
    const res = await apiRequest({
      method: 'get',
      url: `general/get-all-user-types?designationID=${designationID}`,
    });
    return res;
  },
);

export const getProjects = createAsyncThunk('general/getProjects', async () => {
  const res = await apiRequest({
    method: 'get',
    url: `cr-pre-data/getProjects`,
  });
  return res;
});

export const getFormBuilderToken = createAsyncThunk('general/getFormBuilderToken', async () => {
  const res = await apiRequest({
    method: 'get',
    url: `users/get-token`,
  });

  return res;
});
// relation with api
export const getRlationWith = createAsyncThunk('general/getRlationWith', async () => {
  const res = await apiRequest({
    method: 'get',
    url: `general/get-relationships`,
  });

  return res;
});
// get languagets
export const getLanguage = createAsyncThunk('general/getLanguage', async (type) => {
  const res = await apiRequest({
    method: 'get',
    url: `/general/courses-advanced/get-all-languages/${type}`,
  });

  return res;
});
export const postContaboUploads = createAsyncThunk('general/postContaboUploads', async (data) => {
  const res = await apiRequest({
    method: 'post',
    url: `/contabo-upload`,
    data,
  });

  return res;
});

// ------------------------ placement tracker ------------------------------------
export const getPlacementTrackerTable = createAsyncThunk('general/getPlacementTrackerTable', async (params) => {
  const searchParams = new URLSearchParams(params);
  const res = await apiRequest({
    method: 'get',
    url: `/placement-tracker/?${searchParams}`,
  });

  return res;
});
export const addPlacementTracker = createAsyncThunk('general/addPlacementTracker', async (data) => {
  const res = await apiRequest({
    method: 'post',
    url: `/placement-tracker/add`,
    data,
  });

  return res;
});

export const patchPlacementTracker = createAsyncThunk('general/patchPlacementTracker', async (data) => {
  const res = await apiRequest({
    method: 'patch',
    url: `/placement-tracker/${data?.placement_tracker_id}`,
    data,
  });

  return res;
});

export const getPlacementTrackerCourses = createAsyncThunk('general/getPlacementTrackerCourses', async () => {
  const res = await apiRequest({
    method: 'get',
    url: `/placement-tracker/courses`,
  });

  return res;
});
export const getPlacementTrackerCoursesTable = createAsyncThunk(
  'general/getPlacementTrackerCoursesTable',
  async (intern = null) => {
    const res = await apiRequest({
      method: 'get',
      url: `/placement-tracker/courses?intern=${intern}`,
    });

    return res;
  },
);

export const patchPlacementTrackerCourses = createAsyncThunk('general/patchPlacementTrackerCourses', async (data) => {
  const res = await apiRequest({
    method: 'patch',
    url: `/placement-tracker/courses/${data?.course_available_id}`,
    data,
  });

  return res;
});

export const getPlacementTrackerSessions = createAsyncThunk(
  'general/getPlacementTrackerSessions',
  async (trainer_id) => {
    const res = await apiRequest({
      method: 'get',
      url: `placement-tracker/all-sessions/${trainer_id}`,
    });

    return res;
  },
);
export const getPlacementTrackerSessionsStudentDetails = createAsyncThunk(
  'general/getPlacementTrackerSessionsStudentDetails',
  async ({ trainer_id, course_id }) => {
    const res = await apiRequest({
      method: 'get',
      url: `placement-tracker/course-sessions/${trainer_id}/${course_id}`,
    });

    return res;
  },
);
export const getPlacementTrackerAnalyticsTable = createAsyncThunk(
  'general/getPlacementTrackerAnalyticsTable',
  async (params) => {
    const searchParams = new URLSearchParams(params);
    const res = await apiRequest({
      method: 'get',
      url: `/placement-tracker/dashboard-data?${searchParams}`,
    });

    return res;
  },
);
export const getPlacementTrackerAnalyticsTableCards = createAsyncThunk(
  'general/getPlacementTrackerAnalyticsTableCards',
  async (params) => {
    const searchParams = new URLSearchParams(params);
    const res = await apiRequest({
      method: 'get',
      url: `/placement-tracker/dashboard-cards?${searchParams}`,
    });

    return res;
  },
);
export const getPlacementTrackerAnalyticsTableGraph = createAsyncThunk(
  'general/getPlacementTrackerAnalyticsTableGraph',
  async (params) => {
    const searchParams = new URLSearchParams(params);
    const res = await apiRequest({
      method: 'get',
      url: `/placement-tracker/dashboard-cards?${searchParams}`,
    });

    return res;
  },
);
const generalSlice = createSlice({
  name: 'general',
  initialState,
  reducers: {
    clearstate: (state, action) => {
      return {
        ...state,
        state: [],
      };
    },
    clearDistrict: (state, action) => {
      return {
        ...state,
        district: [],
      };
    },
  },
  extraReducers: (builder) => {
    //.................getLocalBodyPreData..............................
    builder.addCase(getLocalBodyPreData.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getLocalBodyPreData.fulfilled, (state, action) => {
      const data = action.payload.data;
      return {
        ...state,
        localBodies: data,
        loading: false,
      };
    });
    // ------------------getCountryPreData-------------------------------
    builder.addCase(getCountryPreData.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getCountryPreData.fulfilled, (state, action) => {
      const data = action.payload.data;
      return {
        ...state,
        country: data,
        loading: false,
      };
    });
    // -----------------------getStatePreData----------------------------
    builder.addCase(getStatePreData.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getStatePreData.fulfilled, (state, action) => {
      const data = action.payload.data;
      return {
        ...state,
        state: data,
        loading: false,
      };
    });
    // ------------------getDistrictPreData----------------------------

    builder.addCase(getDistrictPreData.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getDistrictPreData.fulfilled, (state, action) => {
      const data = action.payload.data;
      return {
        ...state,
        district: data,
        loading: false,
      };
    });
    // -------------updateLead------------------------
    builder.addCase(updateLead.pending, (state, action) => {
      return {
        ...state,
        leadUpdateloading: true,
      };
    });
    builder.addCase(updateLead.fulfilled, (state, action) => {
      return {
        ...state,
        leadUpdateloading: false,
      };
    });
    // ----------------------getCourseFeeOptions----------------------------
    builder.addCase(getCourseFeeOptions.pending, (state, action) => {
      return {
        ...state,
        optionsLoading: true,
      };
    });
    builder.addCase(getCourseFeeOptions.fulfilled, (state, action) => {
      const data = action.payload.data;
      return {
        ...state,
        courseFeeOption: data,
        optionsLoading: false,
      };
    });
    // -----------------getSessionPrize-----------------------------
    builder.addCase(getSessionPrize.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getSessionPrize.fulfilled, (state, action) => {
      const data = action.payload.data;
      return {
        ...state,
        sessionPrize: data,
        loading: false,
      };
    });
    // ---------------getAssetDash----------------------------
    builder.addCase(getAssetDash.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getAssetDash.fulfilled, (state, action) => {
      const data = action.payload.data;
      return {
        ...state,
        assetDash: data,
        loading: false,
      };
    });
    // --------------getAssetDashDetail-------------------------
    builder.addCase(getAssetDashDetail.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getAssetDashDetail.fulfilled, (state, action) => {
      const data = action.payload;
      return {
        ...state,
        assetDashDeatil: data,
        loading: false,
      };
    });
    // ---------------------holdPaymentUpload---------------------

    builder.addCase(holdPaymentUpload.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(holdPaymentUpload.fulfilled, (state, action) => {
      const data = action.payload?.data;
      console.log('holdPaymentUpload', data);

      return {
        ...state,
        fileName: data,
        loading: false,
      };
    });
    // -----------------getPaymentDate------------------
    builder.addCase(getPaymentDate.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getPaymentDate.fulfilled, (state, action) => {
      const data = action.payload.date;
      return {
        ...state,
        paymentDates: data,
        loading: false,
      };
    });
    // -----------------GET TITLE AND FIELDS------------------
    builder.addCase(getTitleAndFields.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getTitleAndFields.fulfilled, (state, action) => {
      return {
        ...state,
        titleAndFields: action.payload.data,
        loading: false,
      };
    });
    // -----------------POSTING CART EDIT REQUEST------------------
    builder.addCase(makeCartEditRequest.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(makeCartEditRequest.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // -----------------UPDATING CART EDIT REQUEST------------------
    builder.addCase(updateCartEditRequest.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(updateCartEditRequest.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // -----------------GETTING CART EDIT REQUESTS------------------
    builder.addCase(getCartEditRequests.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getCartEditRequests.fulfilled, (state, action) => {
      return {
        ...state,
        cartEditRequests: action.payload,
        loading: false,
      };
    });
    // -----------------FINANCE APPROVAL FOR CART REQUEST EDIT-----------------
    builder.addCase(approveOrRejectFinanceForCartEditRequest.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(approveOrRejectFinanceForCartEditRequest.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // -----------------DELETE CART EDIT REQUEST------------------
    builder.addCase(deleteEditRequest.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deleteEditRequest.fulfilled, (state, action) => {
      state.loading = false;
    });
    // -----------------GETTING SINGLE CART EDIT REQUEST------------------
    builder.addCase(getSingleRequest.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSingleRequest.fulfilled, (state, action) => {
      const data = action.payload.data;
      return {
        ...state,
        cartEditRequests: formatDataForDataTable(data),
        loading: false,
      };
    });
    // -----------------GETTING APPROVAL STATUSES------------------
    builder.addCase(getApprovalstatuses.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getApprovalstatuses.fulfilled, (state, action) => {
      const data = action.payload.data;
      return {
        ...state,
        approvalStatuses: data,
        loading: false,
      };
    });
    // -----------------POSTING APPROVAL STATUS------------------
    builder.addCase(postApprovalStatus.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(postApprovalStatus.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // -----------------UPDATING APPROVAL STATUS------------------
    builder.addCase(updateApprovalstatus.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(updateApprovalstatus.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // -----------------POSTING APPROVAL FINANCE------------------
    builder.addCase(postApprovalFinance.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(postApprovalFinance.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // --------------------------------get logs-------------------------------------
    builder.addCase(getEditLogs.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getEditLogs.fulfilled, (state, action) => {
      const data = action.payload.data;
      return {
        ...state,
        editLogs: data,
        loading: false,
      };
    });
    // ------------------------------getUserUnder---------------------------------
    builder.addCase(getUserUnder.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getUserUnder.fulfilled, (state, action) => {
      const data = action.payload.data;
      return {
        ...state,
        dataUserUnder: data,
        loading: false,
      };
    });
    // ------------------------------GET ALL USERS---------------------------------
    builder.addCase(getAllUsersNew.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllUsersNew.fulfilled, (state, action) => {
      const data = action.payload.data;
      return {
        ...state,
        allUsers: data,
        loading: false,
      };
    });
    // --------------------------------------------- wings under department-------------------------------------
    builder.addCase(getWingsUnderdpt.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getWingsUnderdpt.fulfilled, (state, action) => {
      const data = action.payload.data;
      return {
        ...state,
        wingsunderdpt: data,
        loading: false,
      };
    });
    // ------------------------------------ GET ALL DEPARTMENTS----------------------------
    builder.addCase(getAlldepartments.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAlldepartments.fulfilled, (state, action) => {
      const data = action.payload.data;
      return {
        ...state,
        alldepartments: data,
        loading: false,
      };
    });
    // ---------------------------------- GET DESIGNATION UNDER WINGS-----------------------
    builder.addCase(getDesignationUnderWings.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getDesignationUnderWings.fulfilled, (state, action) => {
      const data = action.payload.data;
      return {
        ...state,
        designationsunderwings: data,
        loading: false,
      };
    });
    // -------------------------------- GET USERTYPE UNDER DESIGNATION------------------------
    builder.addCase(getUserTypeUnderDesignation.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getUserTypeUnderDesignation.fulfilled, (state, action) => {
      const data = action.payload.data;
      return {
        ...state,
        usertypeunderdesignation: data,
        loading: false,
      };
    });
    // ------------------------- GET PROJECTS -------------------------------------
    builder.addCase(getProjects.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getProjects.fulfilled, (state, action) => {
      const data = action.payload.data;
      return {
        ...state,
        allprojects: data,
        loading: false,
      };
    });
    // ------------------------- GET FORM BUILDER TOKEN -------------------------------------
    builder.addCase(getFormBuilderToken.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getFormBuilderToken.fulfilled, (state, action) => {
      const data = action.payload.data;
      return {
        ...state,
        formToken: data,
        loading: false,
      };
    });
    // ---------------------Gneral Uplaod Single---------------------

    // builder.addCase(generalSingleUpload.pending, (state, action) => {
    //     return {
    //         ...state,
    //         loading: true,
    //     };
    // });
    // builder.addCase(generalSingleUpload.fulfilled, (state, action) => {
    //     const data = action.payload?.data;
    //     console.log("generalSingleUpload", data);
    //
    //     return {
    //         ...state,
    //         fileName: data,
    //         loading: false,
    //     };
    // });
    //------------------ post state
    builder.addCase(postStatePreData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(postStatePreData.fulfilled, (state) => {
      state.loading = false;
    });
    //------------------ post district
    builder.addCase(postDistrictPreData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(postDistrictPreData.fulfilled, (state) => {
      state.loading = false;
    });
    //----------------- relation With
    builder.addCase(getRlationWith.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getRlationWith.fulfilled, (state, action) => {
      state.loading = false;
      state.relWith = action.payload.data;
    });
    //----------------- Get User
    builder.addCase(getProfileGeneral.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getProfileGeneral.fulfilled, (state, action) => {
      state.loading = false;
      state.user = { ...action.payload.data.profile, ...action.payload.data.latestDetails };
    });
    //----------------- Get Language
    builder.addCase(getLanguage.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getLanguage.fulfilled, (state, action) => {
      state.loading = false;
      state.language = action.payload?.data;
    });
    // contabo upload
    builder.addCase(postContaboUploads.pending, (state) => {
      state.contaboUploading.loading = true;
    });
    builder.addCase(postContaboUploads.fulfilled, (state, action) => {
      state.contaboUploading.loading = false;
      state.contaboUploading.data = action.payload?.data;
    });
    // ----------------- Placement Tracker ---------
    //get
    builder.addCase(getPlacementTrackerTable.pending, (state) => {
      state.placementTrackerTable.loading = true;
    });
    builder.addCase(getPlacementTrackerTable.fulfilled, (state, action) => {
      state.placementTrackerTable.loading = false;
      state.placementTrackerTable.data = action.payload.data;
      state.placementTrackerTable.meta = action.payload.meta;
    });

    // post
    builder.addCase(addPlacementTracker.pending, (state) => {
      state.submitLoading = true;
    });
    builder.addCase(addPlacementTracker.fulfilled, (state, action) => {
      state.submitLoading = false;
    });
    // patch
    builder.addCase(patchPlacementTracker.pending, (state) => {
      state.submitLoading = true;
    });
    builder.addCase(patchPlacementTracker.fulfilled, (state, action) => {
      state.submitLoading = false;
    });
    // get placement courses
    builder.addCase(getPlacementTrackerCourses.pending, (state) => {
      state.placementTrackerCourses.loading = true;
    });
    builder.addCase(getPlacementTrackerCourses.fulfilled, (state, action) => {
      state.placementTrackerCourses.loading = false;
      state.placementTrackerCourses.data = action.payload?.data;
    });
    // get placement courses Table
    builder.addCase(getPlacementTrackerCoursesTable.pending, (state) => {
      state.placementTrackerCoursesTable.loading = true;
    });
    builder.addCase(getPlacementTrackerCoursesTable.fulfilled, (state, action) => {
      state.placementTrackerCoursesTable.loading = false;
      state.placementTrackerCoursesTable.data = action.payload?.data;
    });
    // patch placement courses
    builder.addCase(patchPlacementTrackerCourses.pending, (state) => {
      state.submitLoading = true;
    });
    builder.addCase(patchPlacementTrackerCourses.fulfilled, (state, action) => {
      state.submitLoading = false;
    });

    // get placement sessions
    builder.addCase(getPlacementTrackerSessions.pending, (state) => {
      state.placementTrackerSession.loading = true;
    });
    builder.addCase(getPlacementTrackerSessions.fulfilled, (state, action) => {
      state.placementTrackerSession.loading = false;
      state.placementTrackerSession.data = action.payload?.data;
    });

    // get placement sessions sutdent details
    builder.addCase(getPlacementTrackerSessionsStudentDetails.pending, (state) => {
      state.placementTrackerSessionStudent.loading = true;
    });
    builder.addCase(getPlacementTrackerSessionsStudentDetails.fulfilled, (state, action) => {
      state.placementTrackerSessionStudent.loading = false;
      state.placementTrackerSessionStudent.data = action.payload?.data;
    });
    // get placementAnalytics
    builder.addCase(getPlacementTrackerAnalyticsTable.pending, (state) => {
      state.placementTrackerAnalyticsTable.loading = true;
    });
    builder.addCase(getPlacementTrackerAnalyticsTable.fulfilled, (state, action) => {
      state.placementTrackerAnalyticsTable.loading = false;
      state.placementTrackerAnalyticsTable.data = action.payload.data;
      state.placementTrackerAnalyticsTable.meta = action.payload.meta;
    });
    // get placementAnalytics cards
    builder.addCase(getPlacementTrackerAnalyticsTableCards.pending, (state) => {
      state.placementTrackerAnalyticsTableCards.loading = true;
    });
    builder.addCase(getPlacementTrackerAnalyticsTableCards.fulfilled, (state, action) => {
      state.placementTrackerAnalyticsTableCards.loading = false;
      state.placementTrackerAnalyticsTableCards.data = action.payload.data;
    });
    // get placement Analytics graph
    builder.addCase(getPlacementTrackerAnalyticsTableGraph.pending, (state) => {
      state.placementTrackerAnalyticsTableGraph.loading = true;
    });
    builder.addCase(getPlacementTrackerAnalyticsTableGraph.fulfilled, (state, action) => {
      state.placementTrackerAnalyticsTableGraph.loading = false;
      state.placementTrackerAnalyticsTableGraph.data = Array.isArray(action.payload.data) ? action.payload.data : [];
    });
  },
});

export const { clearDistrict, clearstate } = generalSlice.actions;
export default generalSlice.reducer;
